import { serverUrl } from './serverConfig'
import { genericError } from "../util/errorUtil"
export const getSessionListApi = async (payload) => {
    try {
        const { playerUid, sessionToken } = payload
        const body = {
            "identity": "user.aca.getusersessions",
            "uid": playerUid
        }
        const sessionList = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await sessionList.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const getSessionDataApi = async (payload) => {
    try {
        const { playerUid, sessionId, sessionToken } = payload
        const body = {
            "identity": "user.aca.getusersessionbyid",
            "uid": playerUid,
            "sessionId": sessionId
        }
        const sessionData = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await sessionData.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}